import { cookieManagerInstance } from "../cookies";
import { CustomCookieIdentifier } from "../constants/ShortbreadConfig";

export function validateDeepLink(deepLinkURL: string | null): boolean {
  if (deepLinkURL == null) {
    return false;
  }
  if (deepLinkURL.length < 3 || deepLinkURL.length > 2048) {
    return false;
  }
  //https://regex101.com/r/Swyc9X/2
  const pattern = new RegExp(
    "^$|^(https?:\\/\\/)?(?:www\\.|(?!www))[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$|^(http?s{0,1}:\\/\\/)(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\\/.*)?$",
    "gm"
  );
  return pattern.test(deepLinkURL);
}

export function getDeepLink(): string | null {
  const url =
    cookieManagerInstance.getSessionStorage(
      CustomCookieIdentifier.DEEPLINK.name
    ) ?? null;
  if (url === "null") {
    return null;
  }
  return url;
}
